module.exports = __webpack_public_path__ + "img/no-sale.eb80da2c.png";